const API_BASE_URL = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(/\/+$/, '')

const resolveBackendOrigin = () => {
  try {
    return new URL(API_BASE_URL).origin
  } catch {
    if (typeof window !== 'undefined') {
      return window.location.origin
    }
    return ''
  }
}

const BACKEND_ORIGIN = resolveBackendOrigin()

export const resolveMediaUrl = (source?: string | null): string | null => {
  if (!source) return null

  const value = source.trim()
  if (!value) return null

  if (/^(https?:|blob:|data:)/i.test(value)) {
    return value
  }

  let normalized = value.replace(/\\/g, '/')
  // Static files are served from /uploads, rather than /api/v1/uploads.
  // Accept both paths so old saved values render while the backend returns the
  // canonical public URL for all new responses.
  const uploadsIndex = normalized.indexOf('/uploads/')
  if (uploadsIndex > 0) normalized = normalized.slice(uploadsIndex)
  if (!normalized.startsWith('/')) normalized = `/${normalized}`
  if (!BACKEND_ORIGIN) return normalized
  return `${BACKEND_ORIGIN}${normalized}`
}
